module.exports = __webpack_public_path__ + "static/media/oab-caragua-logo.61d29fe8.png";